import { useCreateUserMutation, useEditUserMutation } from "../../../../../_features/userManagement/api/userApiSlice";
import { flattenRoleField, splitPhoneField, buildOrganisationUpdate } from "../utils/userManagementFormRules";

/**
 * Data/API Layer - mirrors every other migrated modal's mutations hook,
 * using useCreateUserMutation/useEditUserMutation imported directly from
 * `_features/userManagement/api/userApiSlice.js` (per userManagementApi.js's
 * header comment - this fat slice has too wide an external fan-out to split
 * up further).
 */
export function useUserManagementFormMutations() {
  const [createUser, { isLoading: isCreating }] = useCreateUserMutation();
  const [updateUser, { isLoading: isUpdating }] = useEditUserMutation();

  async function submitUser({ mode, validData, rowData, currentOrgId }) {
    const flatData = splitPhoneField(flattenRoleField(validData));

    if (mode === "create") {
      return await createUser(flatData).unwrap();
    }

    const updateData = { ...flatData, _id: rowData?._id };
    const organisationUpdate = buildOrganisationUpdate(flatData, rowData, currentOrgId);
    if (organisationUpdate) {
      updateData.organisationUpdate = organisationUpdate;
    }

    return await updateUser(updateData).unwrap();
  }

  return {
    submitUser,
    isSubmitting: isCreating || isUpdating,
  };
}
